import React from "react";

const WatermarkOverlay = ({ text = "WATERMARK", opacity = 0.3 }) => {
  return (
    <div
      className="absolute inset-0 pointer-events-none overflow-hidden z-10"
      style={{ opacity }}
    >
      <div className="absolute inset-0 flex flex-wrap items-center justify-center gap-16" style={{ transform: "rotate(-30deg) scale(1.5)" }}>
        {Array.from({ length: 12 }).map((_, i) => (
          <span
            key={i}
            className="text-white text-lg font-bold select-none whitespace-nowrap"
            style={{ textShadow: "1px 1px 3px rgba(0,0,0,0.5)" }}
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default WatermarkOverlay;
